import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const CrowdsourcedDealsModalAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "crowdsourced-deals-modal" */ './crowdsourced-deals-modal'),
  componentName: 'CrowdsourcedDealsModal',
});
